import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

/**
 * SAMPLE COPY — the product has no buyers yet.
 * Replace every quote, name and photo with a real buyer review (with
 * permission) before running traffic. US FTC rules prohibit fabricated reviews.
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      "I opened Week 1 on Sunday night and taught it Monday afternoon. First time all term I didn't make up a combo in the car.",
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      "My Saturday group goes from six to twelve. With Starter, Core and Stretch on the same card, everyone dances the same routine and nobody's bored.",
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      'The Freeze-Frame Reset alone was worth it. I get the room back without raising my voice.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Across-the-floor used to be chaos. With the Floor Lanes System, 22 kids crossed the room in order.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      'No song titles, just BPM and style. I use my own clean playlist and the counts still land.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      'The showcase volume took the panic out of recital season. Six weeks, section by section.',
    author: coaches[5].name,
    role: coaches[5].role,
    avatar: coaches[5].avatar,
  },
]
